/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation executeScriptMutation($id: ID!, $version: Int, $input: JSON) {
        result: executeScript(id: $id, version: $version, input: $input)
    }
`;
